<div id="table-filter-accordion" class="mb-3">
  <div class="card br-6 box-shadow border-0">
    <div id="table-filter">
      <div class="card-body d-flex">
        <form class="d-flex w-100" [formGroup]="form" (ngSubmit)="onFilterFormSubmit()">
          <div class="d-flex align-items-center px-4">
            <app-vficon iconName="filter" iconPack="source-system-icons" style="padding-bottom: 2px"></app-vficon>
            <span class="font-weight-bold pl-2" style="font-size: 1.3rem; color: #7e7e7e">Filter</span>
          </div>
          <div class="row filter-container px-4 w-100">
            @for (filterItem of searchedFilterItems; track idx; let idx = $index) {
              <div class="col searched ml-3 my-2">
                <span class="searched-column"
                  >{{
                    (filterItem.columnLabel || filterItem.columnTitle) === "all"
                      ? "ALL"
                      : filterItem.columnLabel || filterItem.columnTitle
                  }}
                </span>
                <span class="text-monospace">{{ filterItem.exactMatch ? "=" : "::" }}</span>
                <span class="searched-text">{{ filterItem.searchText.join(" OR ") }}</span>
                <mat-icon
                  class="material-symbols-outlined input-icon"
                  tooltip="remove filter"
                  matSuffix
                  (click)="removeFilterItem(filterItem.idx, filterItem.exactMatch)"
                >
                  cancel
                </mat-icon>
              </div>
            }
            @if (isSearchBoxOpen) {
              <div #searchTextContainer class="col search-box my-2">
                <mat-form-field appearance="outline" class="mat-form-field custom-filter-input">
                  <input
                    #searchTextInput
                    type="text"
                    name="searchText"
                    [disabled]="disabled"
                    placeholder="Column Name"
                    tooltip='type "Column Name :: Search Text" to filter data contain search text or "Column Name = Search Text" for exact match '
                    class="search-text w-100"
                    [formControl]="searchText"
                    (keyup)="searchColumns($event)"
                    data-cy="search-text-box"
                    matInput
                  />
                  @if (enableExactMatch) {
                    <mat-icon
                      class="material-symbols-outlined input-icon"
                      [ngClass]="{ active: exactMatch }"
                      tooltip="exact match"
                      matSuffix
                      (click)="toggleExactMatch()"
                    >
                      match_word
                    </mat-icon>
                  }
                  <mat-icon
                    class="material-symbols-outlined input-icon"
                    tooltip="remove filter"
                    matSuffix
                    (click)="openSearchBox(false)"
                  >
                    cancel
                  </mat-icon>
                </mat-form-field>

                @if (columnsDropdown) {
                  <div class="list box-shadow">
                    <div class="list-info">Columns</div>
                    @if (typedColumn === "" || "all".includes(typedColumn.toLowerCase())) {
                      <div class="list-item" (click)="selectColumn({ title: 'all', label: 'ALL' })">ALL (Default)</div>
                    }
                    @for (column of sortedColumns; track $index) {
                      @if (column.searchable && column.title && (column.label || column.title).includes(typedColumn)) {
                        <div class="list-item" (click)="selectColumn(column)">
                          {{ column.label || column.title }}
                        </div>
                      }
                    }
                  </div>
                }
              </div>
            }
            @if (!isSearchBoxOpen) {
              <div class="col text-input pt-3 pb-2" (click)="openSearchBox(true)" data-cy="search-text-indicator">
                Click here to search
              </div>
            }
          </div>
        </form>
        @if (!disableDownload) {
          <div class="dropdown d-flex align-items-center pl-4" style="margin-left: auto">
            <button
              [disabled]="disabled"
              class="btn"
              type="button"
              id="dropdownMenuButton"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              data-cy="download-dropdown"
            >
              <app-vficon iconName="download" iconPack="source-mid-render-light-icons"></app-vficon>
            </button>
            <div class="dropdown-menu dropdown-menu-right">
              <button [disabled]="disabled" class="dropdown-item" (click)="clickDownload('all')" data-cy="dl-all">
                Download {{ isDynamic ? "Loaded" : "All" }}
              </button>
              @if ((tableName || "").startsWith("llm-table-")) {
                <button
                  [disabled]="disabled"
                  class="dropdown-item"
                  (click)="clickDownload('loaded')"
                  data-cy="dl-filtered"
                >
                  Download Loaded
                </button>
              }
              @if (filtered) {
                <button
                  [disabled]="disabled"
                  class="dropdown-item"
                  (click)="clickDownload('filtered')"
                  data-cy="dl-filtered"
                >
                  Download Filtered
                </button>
              }
              @if (downloadSelected) {
                <button
                  [disabled]="disabled"
                  class="dropdown-item"
                  (click)="clickDownload('selected')"
                  data-cy="dl-selected"
                >
                  Download Selected
                </button>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </div>
</div>
